import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar/Sidebar';
import { ContentHeader } from './ContentHeader/ContentHeader';
import styles from './AppLayout.module.scss';

interface AppLayoutProps {
    children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setIsMobileMenuOpen(false);
    }, [location]);

    const isAuthPage = location.pathname === '/' || location.pathname === '/auth/callback';

    if (isAuthPage) {
        return <div className={styles.authLayout}>{children}</div>;
    }

    return (
        <div className={styles.appLayout}>
            {isMobileMenuOpen && <div className={styles.mobileOverlay} onClick={() => setIsMobileMenuOpen(false)} />}

            <Sidebar isMobileOpen={isMobileMenuOpen} onMobileClose={() => setIsMobileMenuOpen(false)} />

            <div className={styles.mainArea}>
                <ContentHeader onMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />
                <main className={styles.mainContent}>{children}</main>
            </div>
        </div>
    );
}
